import React from "react";
import AllCategoryUserSitePublisher from "../component/sections/publisher/AllCategoryUserSitePublisher";
import ViewCategoryUserSitePublisher from "../component/sections/publisher/ViewCategoryUserSitePublisher";

const routes = [
  {
    path: "/category-user-site-publisher/customer",
    render: () => <AllCategoryUserSitePublisher />,
    exact: true,
  },
  {
    path: "/category-user-site-publisher/customer/:id",
    render: () => <ViewCategoryUserSitePublisher />,
    exact: true,
  },
];

export default routes;
